import React, { useCallback } from 'react';
import { connect } from "react-redux";

import { tableColumn } from "utils";
import { TableList, ActionButton } from 'components/common';
import SeoExtLinkValue from "../SeoExtLinkValue";


const SeoExtLinkList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, seoExtLink }) => {
  const defaultColumnList = ['id', 'url', 'sites_count', 'template_pages_count', 'pages_count', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    url: tableColumn('Ссылка', 'url', {
      render: (val, item) => <SeoExtLinkValue detail={item} asLink={false} isBack={true}/>,
      sorter: true,
    }),
    sites_count: tableColumn('Кол-во сайтов', 'sites_count', {
      sorter: true,
      width: 120,
    }),
    template_pages_count: tableColumn('Кол-во шабл. страниц', 'template_pages_count', {
      sorter: true,
      width: 120,
    }),
    pages_count: tableColumn('Кол-во страниц', 'pages_count', {
      sorter: true,
      width: 120,
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton
          detail={item}
          modelActions={actions.seoExtLink}
          actions={[{ name: 'edit' }, { name: 'delete' }]}
        />
      ),
    }),
  };

  const onLoad = useCallback(({ query, activeFilter }) => {
    if (activeFilter === undefined) {
      activeFilter = seoExtLink.filter.activeFilter
    }
    actions.seoExtLink.listLoad({ query, activeFilter, locationChange: true });
  }, [seoExtLink, actions]);

  return (
    <TableList
      location={router.location}
      model={seoExtLink}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}

    />
  );
};

const mapState = state => ({
  router: state.router,
  seoExtLink: state.seoExtLink,
});

const mapDispatch = dispatch => ({
  actions: {
    seoExtLink: dispatch.seoExtLink,
  }
});

export default connect(mapState, mapDispatch)(SeoExtLinkList);
